import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface InformDialogData {
  title: string;
  message: string;
  btnText: string;
  btnColor: string;
}  

@Component({
  selector: 'app-inform-dialog',
  templateUrl: './inform-dialog.component.html',
  styleUrls: ['./inform-dialog.component.scss']
})
export class InformDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<InformDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InformDialogData) { }

  ngOnInit(): void {
  }

}
